module.exports = __webpack_public_path__ + "media/images/icon_level-ffddbdad7a243e72cfdc513dce7bdba3.png";